<template>
  <!-- <div class="sidebar" :data-color="backgroundColor"> -->
  <div class="sidebar" :data-color="generateThemeConfig.adminBackgroundColor">
    <div class="logo">
      <a href="#" class="simple-text logo-mini">
        <div class="logo-image">
          <!-- <img :src="logo" /> -->
          <img :src="generateThemeConfig.adminLogo" />
        </div>
      </a>

      <a href="#" class="simple-text logo-normal">{{
        generateThemeConfig.adminTitle
      }}</a>
      <div class="navbar-minimize">
        <!-- <button id="minimizeSidebar" class="btn btn-simple btn-icon btn-neutral btn-round" @click="minimizeSidebar">
          <i class="now-ui-icons text_align-center visible-on-sidebar-regular"></i>
          <i class="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"></i>

        </button>-->
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    backgroundColor: {
      type: String,
      default: "black", // sidebar背景顏色
      validator: value => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      // default: "img/qc_logo.png"
      default: process.env.VUE_APP_LOGO
      // default: 'img/icon-vue.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  computed: {
    generateThemeConfig() {
      let config = {};

      switch (this.userType) {
        case "gaa":
          config.adminBackgroundColor = "orange";
          // config.adminLogo = process.env.BASE_URL + "/img/qc_logo_white.png";
          config.adminLogo = process.env.BASE_URL + process.env.VUE_APP_GAALOGO;
          config.adminTitle = this.$t("Sidebar.GAA.Name");
          break;
        case "eaa":
          config.adminBackgroundColor = "black";
          // config.adminLogo = process.env.BASE_URL + "/img/qc_logo.png";
          config.adminLogo = process.env.BASE_URL + process.env.VUE_APP_EAALOGO;
          config.adminTitle = this.$t("Sidebar.EAA.Name");
          break;
        case "si":
          config.adminBackgroundColor = "green";
          // config.adminLogo = process.env.BASE_URL + "/img/qc_logo_white.png";
          config.adminLogo = process.env.BASE_URL + process.env.VUE_APP_SILOGO;
          config.adminTitle = this.$t("Sidebar.SI.Name");
          break;
        case "line":
          config.adminBackgroundColor = "blue";
          // config.adminLogo = process.env.BASE_URL + "/img/qc_logo_white.png";
          config.adminLogo = process.env.BASE_URL + process.env.VUE_APP_AAALOGO;
          config.adminTitle = "商店後台管理";
          break;
      }

      return config;
    },
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  created() {
    this.$sidebar.toggleMinimize();
  }
};
</script>

<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
